import React, { FC, ReactNode } from "react";
import { useNavigate } from "react-router-dom";

type TLinkProps = {
  text: string | ReactNode;
  className?: string;
  link?: any;
  disabled?: boolean;
  customOnclick?:any,
  propState?:any
};

const Link: FC<TLinkProps> = ({ text, className, link, disabled=false, customOnclick, propState }: TLinkProps) => {
  const navigate = useNavigate();

  const onClickHandler = () => {
    if(disabled) {
      return null
    }
    else {
      if(customOnclick){
        customOnclick()
      }
      else {
        navigate(link, { state: propState });
      }
      
    }
  };

  return (
    <span onClick={onClickHandler} className={`link ${className} ${disabled ? 'disabled' : ''}`}>
      {text}
    </span>
  );
};

export default Link;
